import type { ElevarEvent } from 'types'
import { segment } from '../segment'
import { buildSegmentPayload } from '../utils/segment-payload-builder'
import { getCart } from '../../resources/shopify-cart'

export const productRemovedTransformer = async (item: ElevarEvent) => {
  try {
    const cart = await getCart()
    if (!cart) return item

    const product = item.ecommerce?.remove?.products?.[0]
    if (!product) return item

    const segmentPayload = buildSegmentPayload(cart, product)
    segment.track('Product Removed', segmentPayload)
    return item
  } catch (error) {
    console.error('Error in productRemovedTransformer:', error)
    return item
  }
}
